import axios from 'axios';
import { DOMAIN_KEYS } from 'data/constants/domainApiKey';

const currentDomain: string = window.location.hostname.toString();

export const BASE_API_URL = DOMAIN_KEYS[currentDomain]
    ? DOMAIN_KEYS[currentDomain] + '/api'
    : process.env.REACT_APP_ALIRO_URL + '/api';

const axiosDefault = axios.create({
    headers: {
        Authorization: null,
    },
});

export { axiosDefault };
